import {
  Bookmark,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  WidthType,
} from 'docx';
import { EsrsReportMetric } from '../../Report.types';
import { addEmptySpace } from '../report-helper-functions';
import { tableBorders, TextStyle } from '../reportThemes';
import { QuestionType_Enum_ } from 'models';
import { createDataPointRows } from './datapoints';
import { createMdrm } from './mdrm';

export const createMetricTable = (
  metric: EsrsReportMetric,
  companyCurrency: string,
  uniqueRowRefs: string[]
) => {
  const metricInfo = metric.metric.metric;
  const isUmbrellaMetric = metricInfo.calculation === 'NONE';
  const quantitativeMetricTable = new Table({
    columnWidths: [4000, 2000, 2000],
    margins: {
      top: 60,
      bottom: 60,
      right: 60,
      left: 60,
    },
    width: {
      size: '100%',
      type: WidthType.PERCENTAGE,
    },
    borders: tableBorders,
    rows: [
      new TableRow({
        tableHeader: true,
        children: [
          new TableCell({
            verticalAlign: VerticalAlign.CENTER,
            width: {
              size: '60%',
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph({
                text: !isUmbrellaMetric ? 'Metric' : `${metricInfo.shortTitle ?? metricInfo.title}`,
                style: TextStyle.tableTitle,
              }),
            ],
          }),
          new TableCell({
            verticalAlign: VerticalAlign.CENTER,
            width: {
              size: '20%',
              type: WidthType.PERCENTAGE,
            },
            children: [
              new Paragraph({
                text: 'Total',
                style: TextStyle.tableTitle,
              }),
            ],
          }),
        ],
      }),
      createDataPointRows(metric, companyCurrency, uniqueRowRefs),
    ].flat(),
  });

  if (metric.metric.metric.metricType !== QuestionType_Enum_.Decimal_) return [];

  return quantitativeMetricTable;
};

export const createQuantitativeMetrics = (
  quantitativeMetrics: EsrsReportMetric[],
  companyCurrency: string,
  uniqueRowRefs: string[]
) => {
  const displayedMetrics = quantitativeMetrics.flatMap((metric) => {
    const { shortTitle, title } = metric.metric.metric;

    const hasAnswer = metric.tableData?.result?.Year;

    const metricHeader = hasAnswer
      ? []
      : new Paragraph({
          children: [
            new Bookmark({
              id: metric.metric.metricRef,
              children: [
                new TextRun({
                  text: shortTitle ?? title,
                }),
              ],
            }),
          ],
          style: TextStyle.h4,
        });

    const mdrmSection = createMdrm(metric);

    return [
      metricHeader,
      addEmptySpace(100),
      createMetricTable(metric, companyCurrency, uniqueRowRefs),
      addEmptySpace(100),
      mdrmSection,
      addEmptySpace(250),
    ];
  });

  return displayedMetrics.flat();
};
